import {
  Component,
  ElementRef, Input,
  Optional,
  Self,
} from '@angular/core';
import { NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl, MatFormField, MatLabel, MatSuffix, MatError, MatHint } from '@angular/material/form-field';
import {ErrorStateMatcher, ShowOnDirtyErrorStateMatcher} from '@angular/material/core';
import {MatBaseInputComponent} from '../mat-base-input.component';
import { MatFormFieldFix } from '../mat-form-field/mat-form-field-fix';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-mat-textarea-input',
    providers: [
        { provide: MatFormFieldControl, useExisting: MatTextareaInputComponent },
        { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    ],
    template: `
    <mat-form-field class="regular-form-field"
                    [hintLabel]="hintLabel"
                    [appearance]="appearance"
                    (focusin)="onFocusIn($event)"
                    (focusout)="onFocusOut($event)">
      <mat-label>
        {{label}}
      </mat-label>
      <textarea matInput
                [formControl]="formControl"
                [id]="_id"
                [name]="name"
                [placeholder]="placeholder ? placeholder : inlineLabel ? label : ''"
                [rows]="rows"
                autocomplete="off"
      ></textarea>
      <mat-icon matSuffix class="explanation" *ngIf="!!explanation" matTooltip="{{explanation}}">info_outline</mat-icon>
      <mat-error *ngIf="formControl.invalid">{{firstError()}}</mat-error>
      <mat-hint align="start" *ngIf="!formControl.invalid">{{infoText}}</mat-hint>
    </mat-form-field>
  `,
    styles: [
        '.label-text {vertical-align: middle;}'
    ],
    standalone: true,
    imports: [MatFormField, MatFormFieldFix, MatLabel, MatInput, FormsModule, ReactiveFormsModule, NgIf, MatIcon, MatSuffix, MatTooltip, MatError, MatHint]
})
export class MatTextareaInputComponent extends MatBaseInputComponent {

  @Input() rows = 2;
  constructor(@Optional() @Self() public ngControl: NgControl, public _elementRef: ElementRef<HTMLElement>) {
    super(ngControl, _elementRef);
  }
}
